module.exports = __webpack_public_path__ + "static/media/big_circle_bg.e725d679.svg";